<template lang="pug">
#visualizar-contrato-originacao
    BaseHeader(
        titulo='Contrato de originação',
        :voltarPara='true',
        :exibeBotao='false'
    )

    section.visualizar-contrato-originacao__body
        .visualizar-contrato-originacao__card
            h1 Dados do contrato de originação
            card
                .row
                    .col-2.data-display
                        span.data-title
                            | N. Contrato
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.numeroContrato }}
                    .col-2.data-display
                        span.data-title
                            | Cultura
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.culturaNome }}
                    .col-2.data-display
                        span.data-title
                            | Safra
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.safraNome }}
                    .col-2.data-display
                        span.data-title
                            | Volume contratado (t)
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.volumeContratado }}
                    .col-2.data-display
                        span.data-title
                            | Volume recebido (t)
                        span.data-value
                            | 130
                    .col-2.data-display
                        span.data-title
                            | Data do contrato
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.dataContrato }}

                .row
                    .col-2.data-display
                        span.data-title
                            | BP Cliente
                        span.data-value
                            | 0001 - Sinagro
                    .col-2.data-display
                        span.data-title
                            | Fornecedor
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.fornecedor }}
                    .col-2.data-display
                        span.data-title
                            | CNPJ fornecedor
                        span.data-value
                            | 0000000
                    .col-2.data-display
                        span.data-title
                            | Segmento
                        span.data-value
                            | Key Account
                    .col-2.data-display
                        span.data-title
                            | Canal
                        span.data-value
                            | Revenda
                    .col-2.data-display
                        span.data-title
                            | Estado
                        span.data-value
                            | MT

                .row
                    .col-2.data-display
                        span.data-title
                            | Município
                        span.data-value
                            | Sorriso
                    .col-2.data-display
                        span.data-title
                            | Regional
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.regionalNome }}
                    .col-2.data-display
                        span.data-title
                            | Gerente regional
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.gerenteRegionalNome }}
                    .col-2.data-display
                        span.data-title
                            | Gerente comercial
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.gerenteComercialNome }}
                    .col-2.data-display
                        span.data-title
                            | Gestor territorial
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.gestorTerritorialNome }}

            section.visualizar-contrato-originacao__territorio_resumo(
                v-if='mostrarDadosVolumeTerritorio()'
            )
                h2.mt-4.mb-4 Volume por territórios
                    section.d-flex.mb-4
                        .visualizar-contrato-originacao__card__territorios
                            span Volume máximo por território
                            span {{ payload.volumeTerritorios.volumeMaximoTerritorio }} (t)

                        .visualizar-contrato-originacao__card__territorios.mr-4.ml-4
                            span Volume médio por território
                            span {{ payload.volumeTerritorios.volumeMedioTerritorio }} (t)

                        .visualizar-contrato-originacao__card__territorios(
                            style='padding-right: 13px'
                        )
                            span Volume mínimo por território
                            span {{ payload.volumeTerritorios.volumeMinimoTerritorio }} (t)

                    section
                        .visualizar-contrato-originacao__resumo-total.d-flex
                            section(style='width: 50%')
                                .div.table-header.table-border
                                    span Resumo
                                    span Total
                                .div.table-column.table-border
                                    span Volume estimado (t)
                                    span 1000
                                .div.table-column.table-column-active.table-border
                                    span Volume conforme (t)
                                    span {{ payload.resumo.volumeConforme }}
                                .div.table-column.table-border
                                    span Volume com alertas (t)
                                    span {{ payload.resumo.volumeComRestricoes }}
                                .div.table-column.table-column-active.table-border
                                    span Volume entregue (t)
                                    span {{ payload.resumo.volumeEntregue }}

                            section(style='width: 50%')
                                .div.table-header
                                    span Resumo
                                    span Total
                                .div.table-column
                                    span Número de territórios inseridos
                                    span {{ payload.resumo.territoriosInseridos }}
                                .div.table-column.table-column-active
                                    div
                                        i.mr-2.mt-2.flow.flow-verified.verde.custon-icon
                                        span Número de territórios conforme
                                    span {{ payload.resumo.territoriosConforme }}
                                .div.table-column
                                    div
                                        i.mr-2.mt-2.flow.flow-warning-sign.custon-icon
                                        span Número de territórios com alertas
                                    span {{ payload.resumo.territoriosComRestricoes }}
                                .div.table-column.table-column-active
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import Card from '@/components/Card';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';

export default {
    name: 'VisualizarContratoOriginacaoEmpresa',
    components: { Card, BaseHeader },
    data: () => ({
        payload: {
            dadosContratoOriginacao: {
                numeroContrato: null,
                culturaNome: null,
                safraNome: null,
                volumeContratado: null,
                dataContrato: null,
                fornecedor: null,
                regionalNome: null,
                gerenteComercialNome: null,
                gerenteRegionalNome: null,
                gestorTerritorialNome: null,
                status: null
            },
            volumeTerritorios: null,
            resumo: null
        }
    }),
    mounted() {
        this.buscarDados();
    },
    methods: {
        async buscarDados() {
            await ContratoOriginacaoService.buscarContratoOriginacao(
                this.$route.params.id
            )
                .then(({ data }) => {
                    this.payload = data;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                    this.$router.push({ path: '/rastreabilidade/empresa' });
                });
        },
        mostrarDadosVolumeTerritorio() {
            return this.payload.resumo && this.payload.volumeTerritorios;
        }
    }
};
</script>

<style lang="scss" scoped>
#visualizar-contrato-originacao {
    .visualizar-contrato-originacao__body {
        padding: 20px 33px 20px 20px;
        overflow-y: auto;
    }

    .visualizar-contrato-originacao__card {
        gap: 10px;
        display: grid;
        h1 {
            font-size: 16px;
            font-weight: bold;
            line-height: 19px;
            margin-top: 15px;
        }
    }

    .visualizar-contrato-originacao__territorio_resumo {
        h2.mt-4.mb-4 {
            font-size: 16px;
            font-weight: bold;
        }
    }
    .visualizar-contrato-originacao__card__territorios {
        height: 80px;
        width: 100%;
        padding: 20px;
        border-radius: $default-border-radius;
        background: white;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--primary);
    }

    .d-flex.mb-4 {
        margin-top: 15px;
    }
    .visualizar-contrato-originacao__resumo-total {
        width: 100%;
        background: white;
        border-radius: $default-border-radius;
    }

    .table-header {
        color: var(--primary);
        font-weight: 600;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        padding: 15px 20px;
        border-bottom: solid 1px #a1a1a1ff;
    }

    .table-column {
        padding: 15px 20px;
        height: 50px;
        font-size: 14px;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
    }

    .table-column-active {
        background: #ecececcf;
    }

    .table-border {
        border-right: solid 1px #a1a1a1ff;
    }

    .data-display {
        display: flex;
        flex-direction: column;
        padding: 15px 20px;

        .data-title {
            font-size: 14px;
            margin-bottom: 8px;
            color: var(--primary);
            font-weight: 600;
        }

        .data-value {
            font-size: 14px;
            color: #636363;
        }
    }

    .mr-2.mt-2.flow.flow-warning-sign.custon-icon {
        color: var(--warning);
    }
}
</style>
